import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ForwardIcon from "@mui/icons-material/Forward";
import { IconButton, Tooltip } from "@mui/material";
var DataGridActionButtons = function(param) {
    var _param_canDetail = param.canDetail, canDetail = _param_canDetail === void 0 ? false : _param_canDetail, _param_canEdit = param.canEdit, canEdit = _param_canEdit === void 0 ? false : _param_canEdit, _param_canDelete = param.canDelete, canDelete = _param_canDelete === void 0 ? false : _param_canDelete, onClickDetail = param.onClickDetail, onClickEdit = param.onClickEdit, onClickDelete = param.onClickDelete, row = param.row;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            onClickDetail && /*#__PURE__*/ _jsx(Tooltip, {
                title: "상세보기",
                children: /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        size: "small",
                        disabled: !canDetail,
                        onClick: function() {
                            return onClickDetail(row);
                        },
                        children: /*#__PURE__*/ _jsx(ForwardIcon, {})
                    })
                })
            }),
            onClickEdit && /*#__PURE__*/ _jsx(Tooltip, {
                title: "수정하기",
                children: /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        size: "small",
                        disabled: !canEdit,
                        onClick: function() {
                            return onClickEdit(row);
                        },
                        children: /*#__PURE__*/ _jsx(EditIcon, {})
                    })
                })
            }),
            onClickDelete && /*#__PURE__*/ _jsx(Tooltip, {
                title: "삭제하기",
                children: /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        size: "small",
                        disabled: !canDelete,
                        onClick: function() {
                            return onClickDelete(row);
                        },
                        children: /*#__PURE__*/ _jsx(DeleteIcon, {})
                    })
                })
            })
        ]
    });
};
export default /*#__PURE__*/ React.memo(DataGridActionButtons);
